import { render, staticRenderFns } from "./SurveyComplain.vue?vue&type=template&id=b909ac1a&scoped=true"
import script from "./SurveyComplain.vue?vue&type=script&lang=js"
export * from "./SurveyComplain.vue?vue&type=script&lang=js"
import style0 from "./SurveyComplain.vue?vue&type=style&index=0&id=b909ac1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b909ac1a",
  null
  
)

export default component.exports